import pb from "../../lib/pb";

const API_URL =
    "https://api.myfavv.live";

async function request(
    path,
    options = {}
) {
    const response =
        await fetch(
            `${API_URL}${path}`,
            {
                ...options,

                headers: {
                    "Content-Type":
                        "application/json",

                    Authorization:
                        `Bearer ${pb.authStore.token}`,

                    ...(options.headers || {})
                }
            }
        );

    let data = null;

    try {
        data = await response.json();
    } catch {
        data = null;
    }

    if (!response.ok) {
        throw new Error(
            data?.error ||
            data?.message ||
            "Fulfillment request failed."
        );
    }

    return data;
}

export function getDeliveryModes() {
    return request(
        "/fulfillment/modes"
    );
}

export function calculateQuote(
    data
) {
    return request(
        "/fulfillment/quote",
        {
            method:
                "POST",

            body:
                JSON.stringify(
                    data
                )
        }
    );
}

export function createFulfillmentRequest(
    data
) {
    return request(
        "/fulfillment/requests",
        {
            method:
                "POST",

            body:
                JSON.stringify(
                    data
                )
        }
    );
}

export function getFulfillmentRequest(
    id
) {
    return request(
        `/fulfillment/requests/${id}`
    );
}

export function partnerRespond(
    requestId,
    data
) {
    return request(
        `/fulfillment/requests/${requestId}/bid`,
        {
            method:
                "POST",

            body:
                JSON.stringify(
                    data
                )
        }
    );
}

export function acceptBid(
    requestId,
    bidId
) {
    return request(
        `/fulfillment/requests/${requestId}/accept-bid`,
        {
            method:
                "POST",

            body:
                JSON.stringify({
                    bidId
                })
        }
    );
}

export function updateDeliveryStatus(
    deliveryId,
    status,
    message = ""
) {
    return request(
        `/fulfillment/deliveries/${deliveryId}/status`,
        {
            method:
                "POST",

            body:
                JSON.stringify({
                    status,
                    message
                })
        }
    );
}

export function updateDeliveryLocation(
    deliveryId,
    lat,
    lng,
    etaMinutes
) {
    return request(
        `/fulfillment/deliveries/${deliveryId}/location`,
        {
            method:
                "POST",

            body:
                JSON.stringify({
                    lat,
                    lng,
                    etaMinutes
                })
        }
    );
}

export function getPartnerProfile() {
    return request(
        "/fulfillment/partner/me"
    );
}

export function getPartnerRequests() {
    return request(
        "/fulfillment/partner/requests"
    );
}

export function getPartnerDeliveries() {
    return request(
        "/fulfillment/partner/deliveries"
    );
}

export function getManagerPartners() {
    return request(
        "/fulfillment/manager/partners"
    );
}

export function verifyPartner(
    partnerId,
    verificationStatus
) {
    return request(
        `/fulfillment/manager/partners/${partnerId}/verification`,
        {
            method:
                "POST",

            body:
                JSON.stringify({
                    verificationStatus
                })
        }
    );
}